import { OBTENIR_MUNICIPIS } from "./actionTypes";
import { fetchObtenirMunicipis } from "./consultesServidor";

export const obtenirMunicipis = () => {
  return {
    type: OBTENIR_MUNICIPIS,
    promise: fetchObtenirMunicipis()
  };
};
